import React, { useContext, useState } from 'react'
import { mttAjax } from 'app/utils/_mtt-ajax'
import Spinner from 'app/React/Components/misc/Spinner'
import { trimOrderBeforeAjax } from 'app/React/Helpers/DataHelper'
import { goToConfirmationPage } from 'app/utils/goToConfirmationPage'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function PaymentButton(props) {
  const {
    cartItems,
    embeddedConfiguratorToken,
    identifier,
    isAccessoryShop,
    isDealerConfigurator,
    order,
    orderType,
    strings,
    setErrors,
    usePrice,
    useSecurityDeposit,
  } = useContext(ConfiguratorContext)

  const [disabled, setDisabled] = useState(false)

  const footerStrings = strings.footer ?? {}
  const orderDeposit = order.security_deposit ?? 0

  const security_deposit = useSecurityDeposit()
  const price = usePrice()

  const getAjaxDataObject = function () {
    order.security_deposit = security_deposit
    order.price = price
    const trimmed_order = trimOrderBeforeAjax(order, cartItems, isAccessoryShop)
    const action = { action: isDealerConfigurator ? 'configurator_register_dealer_order' : 'configurator_register_order' }

    return { ...action, ...trimmed_order, order_type: orderType }
  }

  const submitPurchase = () => {
    if (props.step_is_valid !== 'true') return

    setErrors({}) // Clear errors
    if (disabled) return

    toggleButtonDisabled(true)
    mttAjax('conf_reg', getAjaxDataObject(), ajaxCallback)
  }

  const toggleButtonDisabled = function (bool) {
    setDisabled(bool)
  }

  const ajaxCallback = function (res) {
    if (res.success === true) {
      if (res.data.session_id) {
        // We are inside an embedded configurator, we need to let the parent know that we need to redirect to Reepay
        if (embeddedConfiguratorToken !== null) {
          window.parent.postMessage(
            { action: 'nellemann_manual_reepay_handling', session_id: res.data.session_id },
            '*'
          )
          return
        }

        new Reepay.WindowCheckout(res.data.session_id)
      } else {
        goToConfirmationPage(identifier, res)
      }
    } else {
      toggleButtonDisabled(false)
      setErrors(res.data.errors)
    }
  }

  let toPaymentLabel = orderDeposit <= 0 ? footerStrings.to_payment_free : footerStrings.to_payment

  if (props.button_text !== null) {
    toPaymentLabel = props.button_text
  }

  return (
    <a
      className={props.classes}
      role='button'
      onClick={submitPurchase}
      id='payment'
      disabled={disabled}
      step_is_valid={props.step_is_valid.toString()}
    >
      {disabled ? <Spinner/> : toPaymentLabel}
    </a>
  )
}

PaymentButton.defaultProps = {
  classes: null,
  step_is_valid: 'false', // step_is_valid is from StepIsValid and means that the
  button_text: null
}

export default PaymentButton
